import clientAxios from "../client";

import type {
  UserLoginType,
  UserRecoverType,
  UserRegisterType,
} from "@/common/types/user";

export async function userLogin(payload: UserLoginType) {
  return await clientAxios.post(`login`, payload);
}

export async function userCheckToken() {
  return await clientAxios.get(`token/validate`);
}

export async function userRegister(payload: UserRegisterType) {
  return await clientAxios.post(`register`, payload);
}

export async function userActivate(hash: string) {
  return await clientAxios.post("activate", {
    hash,
  });
}

export async function userRecover(payload: UserRecoverType) {
  return await clientAxios.post(`recover`, payload);
}

export async function userRecoverValid(payload: UserRecoverType) {
  return await clientAxios.post(`recover/validate`, payload);
}

export async function userRecoverPassword(payload: UserRecoverType) {
  return await clientAxios.post(`recover/password`, payload);
}

export async function userProfile() {
  return await clientAxios.get(`member/profile`);
}

export async function userProfileParch(payload: any) {
  return await clientAxios.patch(`member/profile/patch`, { payload });
}

export async function userAccountByMember(member_id: string) {
  return await clientAxios.get(`account/member/${member_id}/show`);
}

export async function userAccount(account_id: string) {
  return await clientAxios.get(`account/${account_id}/show`);
}

export async function userPatchAccount(
  account_id: string,
  payload: {
    name: string;
    description: string | null;
  },
) {
  return await clientAxios.patch(`account/${account_id}/patch`, {
    payload,
  });
}

export async function userAffiliateList(member_id: string) {
  return await clientAxios.get(`member/${member_id}/affiliate/list`);
}

export async function userInvoices(account_id: string) {
  return await clientAxios.get(`account/${account_id}/subscription/list`);
}
